import { FilePlusArrayBase } from '../FilePlusArrayBase';

export class SearchRetargeting extends FilePlusArrayBase {
  static arrayField = 'keywords';
  keywords = null;
}
